module.exports = __webpack_public_path__ + "static/media/min_circle_dark.75cb3815.svg";